module.exports = __webpack_public_path__ + "static/media/19ESCAP5.79bca3d2.jpg";